import React from "react";

const sizes = {
    "3xl": "text-[22px] font-semibold",
    "2xl": "text-xl font-bold",
    "5xl": "text-2xl font-semibold md:text-[22px]",
    "4xl": "text-[20px] font-bold md:text-[21px]",
    "7xl": "text-md font-bold md:text-2xl sm: text-[22px]",
    "6xl": "text-[16px] font-bold md:text-[20px] sm:text-[18px]",
    "9xl": "text-xl font-bold md:text-[28px] sm: text-[26px]",
    "8xl": "text-xl font-bold md:text-[26px] sm:text-2xl",
    "16xl": "text-3xl font-bold md:text-[52px] sm: text-[46px]",
    "15xl": "text-[30px] font-bold md:text-[44px] sm: text-[38px]",
    "14xl": "text-[26px] font-bold md:text-[39px] sm: text-[33px]",
    "13xl": "text-[30px] font-bold md:text-[38px] sm: text-[32px]",
    "19xl": "text-2xl font-bold md:text-5xl",
    xl: "text-lg font-semibold",
    "18xl": "text-3xl font-extrabold md:text-5xl",
    "17xl": "text-3xl font-bold md:text-5xl",
    "20xl": "text-[100px] font-bold md:text-5xl",
    md: "text-sm font-semibold",
    s: "text-xs font-semibold",
    "12xl": "text-[25px] font-semibold md:text-4xl sm: text-[34px]",
    xs: "text-[10px] font-semibold",
    lg: "text-base font-semibold",
    "11xl": "lg:text-[34px] font-bold md:text-[32px] sm:text-3xl text-2xl",
    "10xl": "text-[32px] font-bold md:text-3xl sm: text-[28px]",
};

function Title({title, className = "", size = '3xl', as, ...restProps}) {
	const Component = as || "h6";
	return (
		<Component className={`text-gray ${className} ${sizes[size]}`} {...restProps} >
            {title}
        </Component>
	);
}

export default Title;
